import store from "@/store";
import VeeValidate from "vee-validate";

export default {
  install(Vue) {
    const locales = {
      lang: Vue.observable({ actual: "pl" }),

      t(key, defaultValue, lang) {
        if (!lang) {
          lang = this.lang.actual;
        }
        return store.getters.getTranslation(lang, key.trim(), defaultValue);
      },
      changeLocale(lang) {
        this.lang.actual = lang;
        document.documentElement.lang = lang;
      }
    };

    Vue.$locales = locales;
    Vue.prototype.$locales = locales;

    Vue.use(VeeValidate);

    const validateDictionary = {
      pl: {
        messages: {
          email: () => Vue.$locales.t("validation.email", "To nie jest email"),
          required: () =>
            Vue.$locales.t("validation.required", "To pole jest wymagane"),
          numeric: () =>
            Vue.$locales.t("validation.number", "To nie jest numer"),
          phoneNumber: () =>
            Vue.$locales.t(
              "validation.phone_number",
              "To nie jest numer telefonu"
            ),
          regex: () =>
            Vue.$locales.t(
              "validation.regex",
              "Pole nie zgadza sie z wymaganiami"
            ),
          min: (_field, arg) =>
            Vue.$locales.t("validation.minimum", "Minimalna liczba znakow") +
            `:${arg}`,
          max: (_field, arg) =>
            Vue.$locales.t("validation.maximum", "Maksymalna liczba znakow") +
            `:${arg}`
        }
      }
    };
    VeeValidate.Validator.extend("phoneNumber", {
      getMessage: _field =>
        Vue.$locales.t("validation.phone_number", "To nie jest numer telefonu"),
      validate: value => /^\+?[0-9]{3}-?[0-9]{6,12}$/.test(value)
    });

    VeeValidate.Validator.extend("noascii", {
      getMessage: _field =>
        Vue.$locales.t("validation.noascii", "Niepoprawne znaki"),
      validate: value => /^[\u0000-\u007f]*$/.test(value)
    });

    VeeValidate.Validator.localize("pl");
    VeeValidate.Validator.localize("pl", validateDictionary.pl);
  }
};
